import React from "react"
import { FormControl } from "react-bootstrap"
import FontAwesome from "react-fontawesome"

export default function CommissionItem({ item, index, loanCommissions, onChange, onRemove, disabled }) {

  item = item ? item : {}
  const { id: commissionId = '' } = item

  return (
    <table className="mb-15 w-100p">
      <tbody>
      <tr>
        <td>
          <FormControl componentClass="select" value={ commissionId }
            onChange={e => onChange(e.target.value, index)}
            disabled={ disabled }>

            <option value='' title='Select element'></option>
            { loanCommissions.filter(item => !item.disabled).map(({ id, name }, ind) =>
              <option key={ ind } value={ id } title={ name }>{ name }</option>)}
          </FormControl>
        </td>
        <td>
          <span className="red cursor-pointer ml-20" onClick={() => onRemove(index)}>
            <FontAwesome name="remove" title='Remove' />
          </span>
        </td>
      </tr>
      </tbody>
    </table>
  )
}



// WEBPACK FOOTER //
// ./src/components/fragments/CommissionItem.js